import {observer} from "mobx-react";
import React from "react";
import  {FontBody2} from "../../../components/fonts/font-body2/font-body2";
import FontHeading4 from "../../../components/fonts/font-heading4/font-heading4";
import {FONT_VARIANT} from "../../../components/fonts/font-props";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import RequestProductStore from "../stores/request-product-store";
import Currency from "../../../components/currency/currency";

interface IProps{
	store:RequestProductStore;
}
const RmaItemSummary:React.FC<IProps> = observer(({store})=>{
    
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
	return (
	<>
		<FontHeading4 variant={FONT_VARIANT.BOLD}>{getTranslation('SUMMARY', pageScope)}</FontHeading4>
		<br/>
		<div className='add-item-grid'>
			<FontBody2>{getTranslation('PAID_AMOUNT', pageScope)}</FontBody2>
			<span className='add-item-justify-end'>
				<FontBody2 variant={FONT_VARIANT.BOLD}>
                    <Currency currencyCode={store.paymentCurrencyCode} amount={store.paidAmountSummary}/>
                </FontBody2>
			</span>
			{ store.restockingFeeSummary !== 0 &&
				<>
					<FontBody2>{getTranslation('RESTOCKING_FEE', pageScope)}</FontBody2>
					<span className='add-item-justify-end'>
						<FontBody2 variant={FONT_VARIANT.BOLD}>
                            <Currency currencyCode={store.paymentCurrencyCode} amount={store.restockingFeeSummary}/>
                        </FontBody2>
					</span>
				</>
			}
			{store.adjustmentsSummary !== 0 &&
				<>
					<FontBody2>{getTranslation('ADJUSTMENTS', pageScope)}</FontBody2>
					<span className='add-item-justify-end'>
						<FontBody2 variant={FONT_VARIANT.BOLD}>
                            <Currency currencyCode={store.paymentCurrencyCode} amount={store.adjustmentsSummary}/>
                        </FontBody2>
					</span>
				</>
			}
			<div className='add-item-balance'>
				<FontBody2 variant={FONT_VARIANT.BOLD}>
                    { store.balanceSummary > 0
                        ? getTranslation('REFUND_TOTAL', pageScope)
                        : getTranslation('CUSTOMER_OWES', pageScope)
                    }
                </FontBody2>
				<span className='add-item-justify-end'>
					<FontBody2 variant={FONT_VARIANT.BOLD}><Currency currencyCode={store.paymentCurrencyCode} amount={store.balanceSummary} absoluteNumber={true}/>
                    </FontBody2>
				</span>
			</div>
		</div>
	</>
	)
});

export default RmaItemSummary;